import React from "react";
import { Card, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentAndAdjustment,fetchDataServiceMeterCategory,notificationDetails } from './stateManegement/dispatch';
import { useForm } from "react-hook-form"

export default function PaymentAndAdjustment({ userData }) {

  const dispatch = useDispatch();
  const { loading, serviceAndMeterCat, apierror,returnData } = useSelector((state) => state.notificatinReducer);
  useEffect(() => {
    dispatch(fetchDataServiceMeterCategory(userData));
  }, [dispatch]);
  
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm()

  const [getAlldetails, setGetAlldetails] = useState()



  const handleBalanceValue = (value) => (e) => {
    let name = e.target.name
    setGetAlldetails({
      ...getAlldetails,
      [name]: e.target.value,

    })
    setValue(name,e.target.value)
  };

  const onSubmit = async (data) => {

    const {
      STATE_NAME: state,
      CIRCLE_NAME: district,
      CIRCLE_CODE: circleCode,
      USERNAME: userName
    } = userData.pDATASET[0];
  
    const getNotificationFrequency = (everyEvent = 0) => ({
      everyEvent
    });
  
    const newObj = {
      state,
      district,
      circleCode,
      userName,
      serviceCategory: data.serviceCategory,
      meterCategory: data.meterCategory,
      paymentConsideration: {
        rechargeAmount: {
          enabled: getAlldetails.RECHARGEAMOUNTENABLED ? 1 : 0,
          value: getAlldetails.RECHARGEAMOUNT ? getAlldetails.RECHARGEAMOUNT : '',
          notificationFrequency: getNotificationFrequency(getAlldetails.RECHARGEAMOUNTENABLED ? 1 : 0)
        },
        adjustmentAmount: {
          enabled: getAlldetails.ADJUSTMENTAMOUNTENABLED ? 1 : 0, 
          value: getAlldetails.ADJUSTMENTAMOUNT ? getAlldetails.ADJUSTMENTAMOUNT : "",
          notificationFrequency: getNotificationFrequency(getAlldetails.ADJUSTMENTAMOUNTENABLED ? 1 : 0),
        },
        otherPaymentAmount: {
          enabled: getAlldetails.OTHERPAYMENTAMOUNTENABLED ? 1 : 0,
          value: getAlldetails.OTHERPAYMENTAMOUNT ? getAlldetails.OTHERPAYMENTAMOUNT : "",
          notificationFrequency: getNotificationFrequency(getAlldetails.OTHERPAYMENTAMOUNTENABLED ? 1 : 0,),
        },
      },
    };  
    try {
      await dispatch(setPaymentAndAdjustment(userData, newObj));
      await dispatch(fetchDataServiceMeterCategory(userData));
      setValue("serviceCategory", '');
      setValue("meterCategory", '');
      window.alert("Payment & Adjustment submitted successfully!");
      setGetAlldetails({})
      // reset();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleCheck = (row) => (e) => {
    let name = e.target.name
    setGetAlldetails({
      ...getAlldetails,
      [name] : e.target.checked,
      [row]: 0
    })
  };


    // Watch the values of both selects
    const ServiceCategory = watch("serviceCategory");
    const MeterCategory = watch("meterCategory");
    const handleSelectChange = async (ServiceCategory, MeterCategory) => {
        try {
          // Wait for the dispatch to complete
          let apiID = 7
          await dispatch(notificationDetails(userData, ServiceCategory, MeterCategory,apiID));
          console.log(returnData)
         
        } catch (error) {
          // Handle error if needed
          console.error("An error occurred:", error);
        }
      };
      useEffect(() => {
        if (returnData?.pDATASET?.[0]) {
          setGetAlldetails(returnData.pDATASET[0]);
          clearErrors("RECHARGEAMOUNT");
          console.log("Disconnection value updated:", returnData?.pDATASET?.[0]);
        }else{
          setGetAlldetails({});
        }
      }, [returnData]);
    
    // Call `handleSelectChange` whenever `ServiceCategory` or `MeterCategory` changes
    useEffect(() => {
      console.log(ServiceCategory,"ServiceCategory")
      if (ServiceCategory?.length != 0 && MeterCategory?.length != 0) {  // Ensure these are not undefined or null
        handleSelectChange(ServiceCategory,MeterCategory);
      }
    
    }, [ServiceCategory, MeterCategory]);  // Include userData as a dependency

  return (
    <>
      <Card
        style={{
          height: "auto",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
            Notification Management - Payment & Adjustment
          </Card.Title>
        </Card.Body>
      </Card>

      <div className="TriffContainer">
        <Card
          style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
        >
          <Card className="custom_card">
            <>
              {" "}
              <div className="custom_container">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Card className="custom_top_container">
                    <Row>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        State
                      </Col>
                      <Col className="customtitle" sm={2}>
                        {" "}
                        Distict
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }} >
                  <input className="inputHide" defaultValue={userData.pDATASET[0].STATE_NAME}   value={userData.STATE_NAME} /> 
                  
                  </Col>
                  <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}  >
                  <input className="inputHide"   defaultValue={userData.pDATASET[0].CIRCLE_NAME}  value={userData.CIRCLE_NAME}  /> 
                  
                  </Col>
                    </Row>{" "}
                  </Card>
                  <div className="customContainer">
                    <div style={{display:"flex", gap:"20px"}}>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Service Category</Form.Label>
                          <Form.Select {...register("serviceCategory",{ required: "This is required." })} aria-label="Default select example">
                            <option value="">Select Service Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "SERVICECATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.serviceCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </div>
                      <div className="mb-3 gap-5 dropdowncustom">
                        <Form.Group>
                          <Form.Label>Meter Category</Form.Label>
                          <Form.Select {...register("meterCategory")} aria-label="Default select example">
                            <option value="">Select Meter Category</option>
                            {serviceAndMeterCat?.pDATASET?.filter(item => item.TYPE === "METERCATEGORY").map(service => (
                              <option key={service.ID} value={service.ID}>
                                {service.NAME}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.meterCategory && <span className="error">This field is required</span>}
                        </Form.Group>
                      </div>
                    </div>
                   


                    <div className="mb-3 pt-3 row_card">
                      <div className="par_card">
                        <div className="checkwithinput">
                          <h6>Payment Consideration </h6>

                       
                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("RechargeAmount")}
                              label="Recharge Amount"
                              name="RECHARGEAMOUNTENABLED"
                              checked={getAlldetails?.RECHARGEAMOUNTENABLED}
                              onChange={handleCheck("RECHARGEAMOUNT")} // Handle specific row
                            />
                            <div className="checkin">
                            <span>&#60;=</span>
                              <Form.Control
                                type="text"
                                {...register("RECHARGEAMOUNT",{required:getAlldetails?.RECHARGEAMOUNTENABLED ? false : getAlldetails?.RECHARGEAMOUNTENABLED })} 
                               
                                value={getAlldetails?.RECHARGEAMOUNT || ""}
                                name="RECHARGEAMOUNT"
                                onChange={handleBalanceValue("RechargeAmount")}
                                disabled={!getAlldetails?.RECHARGEAMOUNTENABLED}
                                defaultValue={getAlldetails?.RECHARGEAMOUNT}
                                maxLength={2}
                              />
                              <span>%</span>
                              {errors.RECHARGEAMOUNT && <span className="error">required</span>}
                            </div>
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("AdjustmentAmount")} 
                              label="Adjustment Amount "
                              name="ADJUSTMENTAMOUNTENABLED"
                              checked={getAlldetails?.ADJUSTMENTAMOUNTENABLED}
                              onChange={handleCheck("ADJUSTMENTAMOUNT")} // Handle specific row
                            />
                              <div className="checkin">
                              <span>&#60;=</span>
                              <Form.Control
                                 {...register("ADJUSTMENTAMOUNT",{required:getAlldetails?.ADJUSTMENTAMOUNTENABLED ? false : getAlldetails?.ADJUSTMENTAMOUNTENABLED})}
                              type="text"
                                name="ADJUSTMENTAMOUNT"
                              value={getAlldetails?.ADJUSTMENTAMOUNT || ""}
                              defaultValue={getAlldetails?.ADJUSTMENTAMOUNT}
                              onChange={handleBalanceValue("AdjustmentAmount")}
                              disabled={!getAlldetails?.ADJUSTMENTAMOUNTENABLED}
                              
                              maxLength={2}
                            />
                              <span>%</span>
                              {errors.ADJUSTMENTAMOUNT && <span className="error">required</span>}
                              </div>
                          
                          </Form.Group>

                          <Form.Group className="checkinput">
                            <Form.Check
                              inline
                              {...register("OtherPaymentAmount")} 
                              label="Other Payment Amount"
                              name="OTHERPAYMENTAMOUNTENABLED"
                              checked={getAlldetails?.OTHERPAYMENTAMOUNTENABLED}
                              onChange={handleCheck("OTHERPAYMENTAMOUNT")} // Handle specific row
                              
                            />
                             <div className="checkin">
                             <span>&#60;=</span>
                             <Form.Control type="text"
                              {...register("OTHERPAYMENTAMOUNT",{required:getAlldetails?.OTHERPAYMENTAMOUNTENABLED ? false : getAlldetails?.OTHERPAYMENTAMOUNTENABLED})}
                              value={getAlldetails?.OTHERPAYMENTAMOUNT || ""}
                              defaultValue={getAlldetails?.OTHERPAYMENTAMOUNT}
                              name="OTHERPAYMENTAMOUNT"
                              onChange={handleBalanceValue("OtherPaymentAmount")}
                              disabled={!getAlldetails?.OTHERPAYMENTAMOUNTENABLED}
                        
                              maxLength={2}
                            />
                             <span>%</span>
                             {errors.OTHERPAYMENTAMOUNT && <span className="error">required</span>}
                             </div>
                            
                          </Form.Group>
                        </div>

                        <div className="checkBoxs">
                          <h6>Notification Frequency</h6>

                          <Col  >
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                      
                                    inline
                                    {...register("RechargeAmountEveryEvent")}

                                    label="Every Event"
                                    name="RechargeAmountEveryEvent"
                                    checked={getAlldetails?.RECHARGEAMOUNTENABLED}
                               
                                    // disabled={inputValues.MeterBalanceEveryEvent}
                                    // defaultChecked={true}
                                    defaultChecked={getAlldetails?.RECHARGEAMOUNTEVENT}
                                    // disabled={!checkedRows.RechargeAmount}
                                  />
                                </Form.Group>
    
                              
                            </div>
                          </Col>
                          <Col>
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    label="Every Event"
                                    name="AdjustmentAmountEveryEvent"
                                    //  disabled={!getAlldetails?.ADJUSTMENTAMOUNTEVENT}
                                    {...register("AdjustmentAmountEveryEvent")}
                                    checked={getAlldetails?.ADJUSTMENTAMOUNTENABLED}
                                
                                  />
                                </Form.Group>
                              
                            </div>
                          </Col>
                          <Col >
                            <div className="checkrows">
                                <Form.Group>
                                  <Form.Check
                                    inline
                                    label="Every Event"
                                    {...register("OtherPaymentAmountEveryEvent")}
                                    value="OtherPaymentAmountEveryEvent"
                                
                                    name="OtherPaymentAmountEveryEvent"
                                    checked={getAlldetails?.OTHERPAYMENTAMOUNTENABLED}
                                    //  disabled={getAlldetails?.OTHERPAYMENTAMOUNTEVENT}
                                  />
                                </Form.Group>
                          
                            </div>
                          </Col>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3" style={{ marginTop: 40, marginLeft: "10px" }}>
                    <div className="btn_div" >

<button className="btn btn-primary"
  type="button"
  onClick={() => {
    reset(); // Clears all form fields to default (empty) values
  }}
>
  Clear All
</button>

<input className="btn btn-primary" type="submit" value="SUBMIT" />
{/* <Button variant="primary" onClick={handleSubmit}>Submit</Button> */}
</div>
       
                  </div>
                  </div>
                 
                </Form>
              </div>
            </>
          </Card>
        </Card>
      </div>
    </>
  );
}
